import type WarrantySelectionEnum from '@/app/enums/WarrantySelectionEnum';
import type { ListProduct } from '@/queries/utils/mapProductFragmentToListProduct';

import type { WarrantyObject } from '../_types/WarrantyObject';
import getExtendedWarrantyId from './getExtendedWarrantyId';
import getExtendedWarrantySku from './getExtendedWarrantySku';
import getHasSelectedWarranty from './getHasSelectedWarranty';

export interface BuildWarrantyObjectProps {
  fbc: string | null;
  fbp: string | null;
  image_url: string | null | undefined;
  url: string;
  threeYearWarranty: ListProduct | undefined;
  twoYearWarranty: ListProduct | undefined;
  warrantySelection: WarrantySelectionEnum;
}

export default function buildWarrantyObject({
  twoYearWarranty,
  threeYearWarranty,
  warrantySelection,
  ...rest
}: BuildWarrantyObjectProps): WarrantyObject {
  const productId = getExtendedWarrantyId(warrantySelection);
  const warrantySku = getExtendedWarrantySku(warrantySelection) ?? '';
  const isTwoYearWarranty = getHasSelectedWarranty(
    warrantySku,
    twoYearWarranty,
  );
  const isThreeYearWarranty = getHasSelectedWarranty(
    warrantySku,
    threeYearWarranty,
  );
  let selectedWarranty = null;
  switch (true) {
    case isTwoYearWarranty:
      selectedWarranty = twoYearWarranty;
      break;
    case isThreeYearWarranty:
      selectedWarranty = threeYearWarranty;
      break;
  }
  return {
    currency: selectedWarranty?.price?.currencyCode ?? 'USD',
    price: selectedWarranty?.price?.amount,
    product_id: productId,
    selectedWarranty,
    sku: warrantySku,
    variant: selectedWarranty?.variants[0]?.productId,
    warrantySelection,
    ...rest,
  };
}
